module.exports = __webpack_public_path__ + "static/img/tmp.b2f290f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tmp.jpg
// module id = mjaO
// module chunks = 1